// FlipYard yard directory — FlipYard ONLY. No shared code with Aquagga.
// The real Pull-A-Part / U-Pull-&-Pay location list, discovered 2026-08-12 by probing
// inventoryservice.pullapart.com/Vehicle/NewOnYard across locIds and reading each yard's
// own locName back (no fabricated ids — every entry returned live inventory). This drives
// the yard PICKER so a user chooses a real yard by name instead of typing a mystery number.
// Refresh: re-run scripts/discover-yards.ts if the chain opens or closes a location.

export type YardEntry = { locId: number; name: string; chain: "pullapart" };

export const PULLAPART_YARDS: YardEntry[] = [
  { locId: 25, name: "Akron", chain: "pullapart" },
  { locId: 36, name: "Albuquerque", chain: "pullapart" },
  { locId: 21, name: "Atlanta East", chain: "pullapart" },
  { locId: 4, name: "Atlanta North", chain: "pullapart" },
  { locId: 3, name: "Atlanta South", chain: "pullapart" },
  { locId: 9, name: "Augusta", chain: "pullapart" },
  { locId: 39, name: "Aurora", chain: "pullapart" },
  { locId: 16, name: "Baton Rouge", chain: "pullapart" },
  { locId: 5, name: "Birmingham", chain: "pullapart" },
  { locId: 24, name: "Canton", chain: "pullapart" },
  { locId: 7, name: "Charlotte", chain: "pullapart" },
  { locId: 35, name: "Cincinnati", chain: "pullapart" },
  { locId: 11, name: "Cleveland West", chain: "pullapart" },
  { locId: 38, name: "Colorado Springs", chain: "pullapart" },
  { locId: 20, name: "Columbia", chain: "pullapart" },
  { locId: 30, name: "Corpus Christi", chain: "pullapart" },
  { locId: 40, name: "Denver", chain: "pullapart" },
  { locId: 29, name: "El Paso", chain: "pullapart" },
  { locId: 43, name: "Fort Myers", chain: "pullapart" },
  { locId: 41, name: "Houston", chain: "pullapart" },
  { locId: 18, name: "Indianapolis", chain: "pullapart" },
  { locId: 15, name: "Jackson", chain: "pullapart" },
  { locId: 10, name: "Knoxville", chain: "pullapart" },
  { locId: 12, name: "Lafayette", chain: "pullapart" },
  { locId: 8, name: "Louisville", chain: "pullapart" },
  { locId: 17, name: "Memphis", chain: "pullapart" },
  { locId: 13, name: "Montgomery", chain: "pullapart" },
  { locId: 6, name: "Nashville", chain: "pullapart" },
  { locId: 14, name: "New Orleans West", chain: "pullapart" },
  { locId: 34, name: "Orlando", chain: "pullapart" },
  { locId: 37, name: "Phoenix", chain: "pullapart" },
  { locId: 42, name: "Pittsburgh", chain: "pullapart" },
  { locId: 27, name: "Tucson", chain: "pullapart" },
  { locId: 33, name: "West Palm Beach", chain: "pullapart" },
  { locId: 19, name: "Winston-Salem", chain: "pullapart" },
];

export function yardName(locId: number): string {
  return PULLAPART_YARDS.find((y) => y.locId === locId)?.name ?? `Yard ${locId}`;
}
